const API_URL = process.env.REACT_APP_API_URL;

// Recupero dati iniziali form
export async function getHomePageData() {
    const res = await fetch(`${API_URL}/getHomePageData`, { method: "POST" });
    if (!res.ok) throw new Error("Errore caricamento dati iniziali");
    return res.json();
}


export async function callAPI(endpoint, formData) {
    const body = new URLSearchParams(formData).toString();

    const res = await fetch(`${API_URL}/${endpoint}`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body,
    });

    if (!res.ok) {
        throw new Error(`Errore in ${endpoint}`);
    }
    return res.json();
}


// Endpoints per visualizzazioni
export function categoryCost(data) {
    return callAPI("categoryCost", data);
}

export function departmentCost(data) {
    return callAPI("departmentCost", data);
}

export function peopleCost(data) {
    return callAPI("peopleCost", data);
}

